module.exports = __webpack_public_path__ + "img/27.2333ff3c.png";